export enum WA_Screen {
  UnderConstruction = 'underConstruction',
  Login = 'login',
  WorkplacesMap = 'workplacesMap',
  WorkplaceDetails = 'workplaceDetails',
  TargetProductList = 'targetProductList',
  ProductList = 'productList',
  ProductDetails = 'productDetails',
  UnadressedWorkplacesList = 'unadressedWorkplacesList',
  AddressedWorkplacesList = 'adressedWorkplacesList',
  SearchFilter = 'mapSearchFilter',
  StatusBulkChange = 'statusBulkChange',
  EditProduct = 'editProduct',
  ProgressCheck = 'progressCheck',
  BranchSummary = 'branchSummary',
  BusinessSummary = 'businessSummary',
  RecoverySupportMenu = 'supportMenu',
  UserSearch = 'userSearch',
}
